<template>
	<AppButton
		startIcon="assets/v2/image/icons/plus.svg"
		:label="$t('orders.create-return')"
		@click="createReturnDialogStore.openDialog"
	/>
</template>

<script setup>
import { useCreateReturnDialogStore } from '../../../stores/create-return-dialog';

const createReturnDialogStore = useCreateReturnDialogStore();
</script>

<style lang="scss" scoped></style>
